import { xBaseTheme } from "@stoneage/XDL/types";

export default {
    defaultProps: {
        typographyProps: {
            size: "12px",
            lineHeight: "18px",
        },
    },
} as xBaseTheme["tooltip"];
